import { Incident } from '../microservices';
import { getBaseUrl } from '../../maps/apiEnvironmentMap';

const API_KEY = process.env.REACT_APP_API_KEY;
export class IncidentRequestGET {
  readonly method: string = 'incidents?limit=50&offset=0&order%5Bid%5D=asc';
  public buildURL() {
    let baseURL = getBaseUrl('locker');
    let url = `${baseURL}/${this.method}`;
    return url;
  }
  public generateConfig(token: string) {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'dhl-api-key': API_KEY,
      },
    };
    return config;
  }
}
export type IncidentResponseGET = {
  status: string;
  message: string;
  data: {
    incidents: Incident[];
    message: string;
    errors: any;
  };
};
